"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  pointer-events: ${(p) => (p.disabled ? "none" : "all")};
  opacity: ${(p) => (p.disabled ? "0.5" : "1")};
  display: grid;
  grid-template-columns: repeat(${(p) => p.count}, 1fr);
  box-shadow:
    ${({ theme }) => theme.multiSwitch.boxShadows.top},
    ${({ theme }) => theme.multiSwitch.boxShadows.bottom};
  border-radius: ${({ theme }) => theme.radius};
  position: relative;
  background: ${({ theme }) => theme.multiSwitch.background.normal};
  height: ${({ height }) => `${height !== null && height !== void 0 ? height : "40px"}`};
`;
//# sourceMappingURL=style.js.map